<div class="p-grid">
    <div class="p-col-2">
    </div>
    <div class="p-col-10 p-d-flex">
        <div class="p-text-center" style="flex-grow: 1;">
            <ng-container *ngFor="let s of menus">
                <button pButton pRipple type="button" [label]="s.label" (click)="getItems(s)" 
                class="p-mx-1" [ngClass]="{'p-button-text': !s.active}"></button>
            </ng-container>
        </div>
        <div class="p-text-right">
            <input type="text" pInputText placeholder="Search">
        </div>
    </div>
</div>

<p-splitter [panelSizes]="[15,85]">
    <ng-template pTemplate>
        <div class="card" style="background:#fff;width: 100%;">
            <p-panelMenu [model]="items" [style]="{'width':'100%'}" [multiple]="false"></p-panelMenu>
            <div class="p-d-flex">
                <span style="color: var(--primary-color);" class="p-mt-2">
                    <i class="fa fa-cogs"></i>
                </span>
                <hr style="width: 100%;">
            </div>
            <p-panelMenu [model]="commonItems" [style]="{'width':'100%'}" [multiple]="false"></p-panelMenu>
        </div>
    </ng-template>
    <ng-template pTemplate>
        <div class="card" style="background:#fff;width: 100%;">
            <div class="card">
                <div *ngIf="selectedWindow == 'add-account'">
                    <h5>Create Account</h5>
                    <pdf-viewer [src]="pdfSrc"
                    [render-text]="true"
                    style="display: block;height: 1000px;"
                    ></pdf-viewer>
                </div>
                <div *ngIf="selectedWindow == 'edit-account'">
                    <h5>Update Account</h5>
                        
                </div>
            </div>
        </div>
    </ng-template>
</p-splitter>
